module.exports = __webpack_public_path__ + "img/EARRINGS RED.0d35ab2.svg";